/**
 * Local Language List Component
 *
 * Single Responsibility: Manages and displays a list of local language items
 * Follows SOLID principles:
 * - Single Responsibility: Only responsible for rendering a list of local languages
 * - Open/Closed: Open for extension via props, closed for modification
 * - Dependency Inversion: Depends on LocalLanguageItem component interface, not concrete implementation
 */

import React from 'react';
import { spacing } from '@/design-system/utils';
import { LocalLanguageItem } from './LocalLanguageItem';
import { LocalLanguageListProps } from './types';

/**
 * Local Language List Component
 * Renders a list of local language items with consistent spacing
 */
export const LocalLanguageList: React.FC<LocalLanguageListProps> = ({
  items,
  className,
}) => {
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: spacing[3],
        width: '100%',
      }}
      className={className}
    >
      {items.map(language => (
        <LocalLanguageItem key={language.id} language={language} />
      ))}
    </div>
  );
};
